import { render, staticRenderFns } from "./ResourceListFilter.vue?vue&type=template&id=0b320a7e&scoped=true"
import script from "./ResourceListFilter.vue?vue&type=script&lang=js"
export * from "./ResourceListFilter.vue?vue&type=script&lang=js"
import style0 from "./ResourceListFilter.vue?vue&type=style&index=0&id=0b320a7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b320a7e",
  null
  
)

export default component.exports